export default "__VITE_ASSET__BnfiG3TU__"